<template>
  <div class="lock-log-img-view">
    <div class="top-title">
      <div class="title">
        <span class="title-item">门锁编码：{{ logData.deviceCode || '--' }}</span>
        <span class="title-item">房源名称：{{ logData.roomName || '--' }}</span>
      </div>
      <div class="sub-title">
        点击抓拍图片可查看大图
      </div>
    </div>
    <div class="img-list">
      <div class="img-item" v-for="item in (logData.captureRecordDTOList || [])" :key="item">
        <div class="img-line">
          <div class="img-face">
            <el-image class="image" :src="item.faceUrl" fit="cover" :preview-src-list="[item.faceUrl]"></el-image>
            <span class="desc">人脸照片</span>
          </div>
          <div class="img-back">
            <el-image class="image" :src="item.faceBgUrl" fit="cover" :preview-src-list="[item.faceBgUrl]"></el-image>
            <span class="desc">背景照片</span>
          </div>
        </div>
        <span class="cap-time">抓拍时间：{{ item.captureTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
@descColor: #909399;

.lock-log-img-view {
  position: relative;
  .top-title {
    padding-left: 5px;
    margin-bottom: 10px;
    .title-item {
      margin-right: 40px;
      margin-bottom: 10px;
      font-size: 16px;
    }
    .sub-title {
      color: @descColor;
    }
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
    .img-item {
      padding: 10px 15px;
      margin: 0px 5px 10px 5px;
      width: 280px;
      border: 1px solid #DCDFE6;
      border-radius: 2px;
    }
    .img-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
    }
    .img-face, .img-back {
      display: flex;
      align-items: center;
      flex-direction: column;
      .image {
        width: 108px;
        height: 98px;
      }
      .desc {
        margin-top: 5px;
        color: @descColor;
      }
    }
    .img-face {
      margin-right: 15px;
    }
    .cap-time {
      color: @descColor;
    }
  }
}
</style>